import AdminLayout from "../Attachments/AdminLayout";
import HomePreview from "./HomePreview";
import HomeForm from "./HomeForm";
import { useRef } from "react";
import { useScreenSize } from "../../../hooks/useScreenSize";

interface HomepageIndexProps {
  home_page_data: any;
  home_page_errors: any;
}

export default function HomepageIndex({ home_page_data, home_page_errors }: HomepageIndexProps) {
  const homePreviewRef = useRef<HTMLDivElement>(null)
  const { screenLargerThan } = useScreenSize()

  return (
    <AdminLayout>
      <div style={{
        display: 'flex',
        flexDirection: screenLargerThan('md') ? 'row' : 'column',
        gap: '8px',
        flex: 1,
        minHeight: 0,
      }}>
        <div style={{
          flex: 2,
          overflowX: 'hidden',
          backgroundColor: '#ddd'
        }}>
          <HomeForm
            serverData={home_page_data || {}}
            serverErrors={home_page_errors || {}}
            homePreviewRef={homePreviewRef}
          />
        </div>
        <div style={{
          flex: 1,
          minHeight: 0,
          overflow: 'hidden'
        }}>
          <HomePreview
            ref={homePreviewRef}
          />
        </div>
      </div>
    </AdminLayout>
  )
}
